module.exports = __webpack_public_path__ + "img/momo_cta_button_finish.0e4feb87.png";